import NiceModal, { useModal } from "@ebay/nice-modal-react";
import SideModal from "/src/components/modal/SideModal/SideModal";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import { MANAGER_GUIDE } from "../../data/scorecard";
import "../../styles/callEvaluation.css";

const ManagerGuideModal = NiceModal.create(() => {
    const modal = useModal();
    const { onClose } = useModalHelper(modal);

    return (
        <SideModal name="manager-guide-modal" id={modal.id} autoClose="true" onClose={onClose} style={{ width: "520px" }}>
            <div className="button-leave" id="close_modal_container" onClick={() => onClose()}>
                <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
            </div>

            <div className="ce-guide">
                <h2><i className="fas fa-book-open"></i> Manager call listening guide</h2>
                <p className="ce-guide__intro">Keep this open while you listen — everything the scorecard expects, at a glance.</p>

                {MANAGER_GUIDE.map((entry) => (
                    <div key={entry.title} className="ce-guide__entry">
                        <h4>{entry.title}</h4>
                        {entry.levels && (
                            <ul className="ce-guide__levels">
                                {entry.levels.map((level) => (
                                    <li key={level.value} className={"ce-guide__level s" + level.value}>
                                        <b>{level.value}</b>
                                        <span>{level.text}</span>
                                    </li>
                                ))}
                            </ul>
                        )}
                        {entry.steps ? (
                            <ol className="ce-guide__steps">
                                {entry.steps.map((step) => <li key={step}>{step}</li>)}
                            </ol>
                        ) : (
                            entry.text && <p>{entry.text}</p>
                        )}
                    </div>
                ))}
            </div>
        </SideModal>
    );
});

export default ManagerGuideModal;
